// adminBilling.reducer.js
import { adminBillingConstants } from "../actions/constants"

const initState = {
    loading: false,
    transactions: [],
    promos: [],
    analytics: {
        totalVirtualMoneyGiven: 0
    },
    totalAll: 0,
    totalPages: 0,
    error: null,
}

export default (state = initState, action) => {
    switch (action.type) {
        case adminBillingConstants.GET_ALL_TRANSACTIONS_REQUEST:
        case adminBillingConstants.CREATE_PROMO_REQUEST:
        case adminBillingConstants.MODIFY_BALANCE_REQUEST:
        case adminBillingConstants.GET_ALL_PROMOS_REQUEST:
        case adminBillingConstants.TOGGLE_PROMO_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            }

        case adminBillingConstants.GET_ALL_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                transactions: action.payload.transactions || [],
                totalAll: action.payload.totalAll || action.payload.total || 0,
                totalPages: action.payload.totalPages || 0
            }

        case adminBillingConstants.GET_ALL_PROMOS_SUCCESS:
            return {
                ...state,
                loading: false,
                promos: action.payload.promos || [],
                analytics: action.payload.analytics || { totalVirtualMoneyGiven: 0 },
                totalAll: action.payload.totalAll || action.payload.total || 0,
                totalPages: action.payload.totalPages || 0
            }

        case adminBillingConstants.CREATE_PROMO_SUCCESS:
        case adminBillingConstants.MODIFY_BALANCE_SUCCESS:
        case adminBillingConstants.TOGGLE_PROMO_SUCCESS:
            return {
                ...state,
                loading: false
            }

        case adminBillingConstants.GET_ALL_TRANSACTIONS_FAILURE:
        case adminBillingConstants.CREATE_PROMO_FAILURE:
        case adminBillingConstants.MODIFY_BALANCE_FAILURE:
        case adminBillingConstants.GET_ALL_PROMOS_FAILURE:
        case adminBillingConstants.TOGGLE_PROMO_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        default:
            return state
    }
}